import type { DynamicEnumsRuleInterface } from 'src/tpbp-configuration/mapper/mappingInterfaces'

const relationsEnumRule: DynamicEnumsRuleInterface[] = [
  {
    expression: () => true,
    getEnumKeys: (record, { currentUser, getRelationEnums }) =>
      getRelationEnums(record, currentUser),
  },
]

export { relationsEnumRule }
